module.exports = __webpack_public_path__ + "static/media/poppins-400.43751174.woff2";